var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jsk-spinner-container",class:{'jsk-spinner-container-static': _vm.static ,'jsk-spinner-container-transparent': _vm.transparent}},[_c('div',{staticClass:"jsk-spinner-group"},[_c('div',{staticClass:"jsk-spinner-spinner"}),_c('div',{staticClass:"jsk-spinner-text"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }